import { Injectable } from '@angular/core'
import { TemplateMessageDialogComponent } from './template-message-dialog.component'
import { ContractTemplate } from '@tokeet-frontend/signature'
import { DialogService } from '@tokeet-frontend/tv3-platform'

@Injectable({
  providedIn: 'root',
})
export class TemplateMessageDialogService {
  constructor(private dialog: DialogService) {}

  public open(item: ContractTemplate) {
    return this.dialog.openFixedDialog(TemplateMessageDialogComponent, {
      width: '800px',
      data: { item },
    })
  }
}
